  (function () {
    var PREF_KEY = 'zendeskWidgetPreference'; // 'minimized' or 'open'
    var MAX_WAIT_MS = 15000;
    var INTERVAL_MS = 300;
    var startedAt = Date.now();

    function applyStoredPreference() {
      try {
        var pref = localStorage.getItem(PREF_KEY);
        if (pref === 'minimized') {
          // If user previously minimized, keep it minimized immediately on load
          console.log('I am in applyStoredPreference');
          console.log(zE);
          zE('webWidget', 'close');
        }else{
          console.log('I am in applyStoredPreference');
        }
      } catch (e) {
        console.warn('Zendesk preference apply error', e);
      }
    }

    function setupZendesk() {
      if (typeof zE !== 'function') return;

      zE(function () {
        var handledInitialOpen = false; // per-page flag

        // Handle all 'open' events
        zE('webWidget:on', 'open', function () {
          
          try {
            console.log('I am in open');
            var pref = localStorage.getItem(PREF_KEY);

            if (!handledInitialOpen) {
              // This is the first open on this page (likely auto-open)
              handledInitialOpen = true;

              if (pref === 'minimized') {
                // User preferred minimized → immediately minimize again
                //zE('webWidget', 'close');
              }
              // If pref is 'open' or not set, do nothing → leave it open
            } else {
              // Subsequent opens on this page are almost certainly user clicks
              // User explicitly opened the widget → remember that
              localStorage.setItem(PREF_KEY, 'open');
            }
          } catch (e) {
            console.warn('Zendesk open handler error', e);
          }
        });

        // Handle 'close' (minimize) events
        zE('webWidget:on', 'close', function () {
          try {
            console.log('I am in close');
            // User minimized → remember preference
            localStorage.setItem(PREF_KEY, 'minimized');
          } catch (e) {
            console.warn('Zendesk close handler error', e);
          }
        });

        // Note: we do NOT call 'open' or 'close' here directly.
        // Zendesk will auto-open according to its own settings.

        // Apply persisted preference immediately on page load
        applyStoredPreference();
      });
    }

    function waitForZendesk() {
      if (typeof zE === 'function') {
        setupZendesk();
        return;
      }

      if (Date.now() - startedAt > MAX_WAIT_MS) {
        console.warn('Zendesk widget not detected within timeout.');
        return;
      }

      setTimeout(waitForZendesk, INTERVAL_MS);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', waitForZendesk);
    } else {
      waitForZendesk();
    }
  })();